import getColor from "@insite/mobius/utilities/getColor";
import React from "react";

const DataSheetIcon = () => {
    return (
        <svg width="35" height="42" viewBox="0 0 35 42" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#go1or3t24a)" stroke="#002856" strokeWidth="1.5" strokeLinejoin="round">
                <path d="M28.788 5H6.195v10h22.593V5z" strokeLinecap="round" />
                <path
                    d="M19.415 19.5h9.905M19.415 23.5h9.905M19.415 27.5h9.905M19.415 31.5h9.905M19.415 35.5h9.905M5.663 19.5h9.905M5.663 23.5h9.905M5.663 27.5h9.905M5.663 31.5h9.905M5.663 35.5h9.905"
                    strokeLinecap="square"
                />
                <path d="M33.7 1H1.282v40H33.7V1z" strokeLinecap="round" />
            </g>
            <defs>
                <clipPath id="go1or3t24a">
                    <path fill="#fff" transform="translate(.3)" d="M0 0h34.38v42H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default DataSheetIcon;
